module.exports = __webpack_public_path__ + "img/4.630a95b.png";